import { type SagaIterator } from "@redux-saga/core";
import { call, put, takeEvery } from "redux-saga/effects";
import getOrderHistory from "../../services/orderhistory/orderhistory.api";
import {
  type OrderDetailsList,
  OrderHistoryPayload,
} from "../../types/orderhistory";
import { orderHistoryActions } from "./slice";
import { PayloadAction } from "@reduxjs/toolkit";
import { withLoader } from "../loader/saga";

// Worker Sagas
export function* onGetOrderHistory(
  action: PayloadAction<OrderHistoryPayload>
): SagaIterator {
  try {
    const orderHistories: OrderDetailsList = yield* withLoader(function* () {
      return yield call(getOrderHistory, action.payload);
    });
    yield put(orderHistoryActions.fetchAllSucceeded(orderHistories));
  } catch (e: unknown) {
    if (e instanceof Error) {
      yield put(orderHistoryActions.fetchAllFailure(e.message.toString()));
    }
  }
}


// Watcher Saga
function* orderHistoryWatcherSaga(): SagaIterator {
  yield takeEvery(orderHistoryActions.fetchAll.type, onGetOrderHistory);
}

export default orderHistoryWatcherSaga ;
